import { render } from "./DZC_StandNum.vue?vue&type=template&id=29230b8a"
import script from "./DZC_StandNum.vue?vue&type=script&lang=js"
export * from "./DZC_StandNum.vue?vue&type=script&lang=js"

import "./DZC_StandNum.vue?vue&type=style&index=0&id=29230b8a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__